import SpriteSymbol from "../../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lighthttpd",
  "use": "lighthttpd-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"lighthttpd\"><path d=\"M3.67 14.86v.01l1.02-.92-.48-.32-.54 1.23zM17.49 2L.51 10.14l1.89 1.65 14.92-9.67-14.63 9.92.98 2.83.36-1.82L17.49 2 4.38 13.25l-.01.03L8.43 16l9.06-14z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol